$(document).ready(function() {
            // Sticky Header
            $(window).scroll(function() {
                if ($(this).scrollTop() > 40) {
                    $('.header-main').addClass('is-sticky');
                } else {
                    $('.header-main').removeClass('is-sticky');
                }
            });
            
            // Cart Toggle
            $('#cart-toggle').click(function(e) {
                e.preventDefault();
                $(this).toggleClass('active');
                e.stopPropagation();
            });
            
            // Close mini-cart when clicking outside
            $(document).click(function(e) {
                if (!$(e.target).closest('#cart-toggle').length) {
                    $('#cart-toggle').removeClass('active');
                }
            });
            
            // Remove item from mini cart
            $('.cart-item-remove').click(function(e) {
                e.preventDefault();
                $(this).closest('.cart-item').fadeOut(300, function() {
                    $(this).remove();
                    updateMiniCart();
                });
            });
            
            function updateMiniCart() {
                const itemCount = $('.cart-item').length;
                $('#cart-toggle .badge').text(itemCount);
                $('.cart-count').text(itemCount + ' items');
                
                // Calculate subtotal
                let subtotal = 0;
                $('.cart-item').each(function() {
                    const price = $(this).find('.cart-item-price').text().replace('â‚¹', '').replace(',', '');
                    const qty = parseInt($(this).find('.cart-item-qty').text().replace('Qty: ', ''));
                    subtotal += parseFloat(price) * qty;
                });
                
                $('.subtotal-value').text('â‚¹' + subtotal.toLocaleString());
                
                // If no items, show empty cart message
                if (itemCount === 0) {
                    $('.cart-items').html('<p class="text-center py-3">Your cart is empty</p>');
                    $('.cart-subtotal').hide();
                    $('.cart-actions').hide();
                }
            }
            
            // Search Overlay
            $('#search-trigger').click(function() {
                $('#search-overlay').addClass('show');
                setTimeout(function() {
                    $('#search-overlay .search-input').focus();
                }, 300);
            });
            
            $('#search-close').click(function() {
                $('#search-overlay').removeClass('show');
            });
            
            // Close search with escape key
            $(document).keydown(function(e) {
                if (e.keyCode === 27) {
                    $('#search-overlay').removeClass('show');
                }
            });
            
            // Mobile Menu
            $('#mobile-toggle').click(function() {
                $('#mobile-menu').addClass('show');
                $('#overlay').addClass('show');
                $('body').css('overflow', 'hidden');
            });
            
            $('#mobile-close, #overlay').click(function() {
                $('#mobile-menu').removeClass('show');
                $('#overlay').removeClass('show');
                $('body').css('overflow', 'auto');
            });
            
            // Stop propagation on mobile menu
            $('#mobile-menu').click(function(e) {
                e.stopPropagation();
            });
            
            // Dropdown Panel Positioning
            $('.nav-item').hover(
                function() {
                    // On mouseenter
                    const headerHeight = $('.header-main').outerHeight();
                    $(this).find('.dropdown-panel').css('top', headerHeight + 'px');
                },
                function() {
                    // On mouseleave
                }
            );
        });


       $(document).ready(function(){
            var owl = $(".hero-carousel");
            var progressBar = $(".slide-progress-bar");
            var currentSlide = $(".current-slide");
            var totalSlidesSpan = $(".total-slides"); // Renamed to avoid conflict with var totalSlides
            var percent = 0;
            var interval;

            const heroSliderSection = document.querySelector('.hero-slider');
            let enableAutoplay = true; // Default if no setting found
            let autoplayTimeoutMs = 8000; // Default if no setting found

            if (heroSliderSection) {

                const autoplaySetting = heroSliderSection.dataset.enableAutoplay;
                const speedSetting = heroSliderSection.dataset.autoplaySpeed;

                if (autoplaySetting !== undefined) {
                    enableAutoplay = (autoplaySetting === 'true'); // Convert string to boolean
                }
                if (speedSetting) {
                    autoplayTimeoutMs = parseInt(speedSetting, 10); // Convert string to integer
                }
            }


            // Initialize Owl Carousel
            owl.owlCarousel({
                items: 1,
                loop: true,
                nav: true,
                dots: false, // Remove dots entirely
                autoplay: enableAutoplay, // Dynamic
                autoplayTimeout: autoplayTimeoutMs, // Dynamic
                autoplayHoverPause: true,
                smartSpeed: 1000,
                navText: ["<span>&lt;</span>","<span>&gt;</span>"],
                lazyLoad: true,
                mouseDrag: true,
                touchDrag: true,
                pullDrag: true,
                freeDrag: false,
                stagePadding: 0,
                responsive: {
                    0: {
                        nav: true
                    },
                    768: {
                        nav: true
                    }
                },
                onInitialized: function(event) {
                    // Set total slides count dynamically from Owl Carousel event
                    var totalItems = event.item.count;
                    totalSlidesSpan.text(totalItems < 10 ? "0" + totalItems : totalItems); // Dynamic
                    currentSlide.text("01"); // Start at 01 for the first slide

                    // Start progress bar
                    startProgressBar();

                    // Add active class to first slide
                    $(".owl-item.active .hero-slide").addClass("active");
                }
            });

            // Handling slide change
            owl.on('changed.owl.carousel', function(event) {
                // Update current slide count
                // Owl Carousel provides clone items for infinite loop.
                // The current item index needs adjustment to get the "real" slide index.
                var current = event.item.index - event.relatedTarget._clones.length / 2 + 1;
                if (current > event.item.count) {
                    current = current - event.item.count;
                }
                if (current < 1) {
                    current = event.item.count;
                }
                currentSlide.text(current < 10 ? "0" + current : current); // Dynamic

                // Reset and start progress bar
                resetProgressBar();
                startProgressBar();

                // Reset active class for animations
                $(".hero-slide").removeClass("active");
                setTimeout(function() {
                    $(".owl-item.active .hero-slide").addClass("active");
                }, 100);
            });

            // Progress bar functions
            function startProgressBar() {
                // Reset
                resetProgressBar();

                // Ensure interval is based on dynamic autoplayTimeoutMs
                const progressIntervalTime = (autoplayTimeoutMs / 200); // 100% / 0.5% per step = 200 steps

                interval = setInterval(function() {
                    percent += 0.5; // Increment by 0.5%
                    progressBar.css("width", percent + "%");

                    if (percent >= 100) {
                        percent = 0;
                        owl.trigger('next.owl.carousel');
                    }
                }, progressIntervalTime);
            }

            function resetProgressBar() {
                percent = 0;
                clearInterval(interval);
                progressBar.css("width", 0 + "%");
            }

            // Pause progress bar when hovering over carousel
            owl.on('mouseover', function() {
                resetProgressBar();
            });

            owl.on('mouseout', function() {
                startProgressBar();
            });

            // Parallax effect on slide backgrounds
            $(window).on('mousemove', function(e) {
                var x = e.clientX / $(window).width();
                var y = e.clientY / $(window).height();

                $(".slide-bg").css({
                    "transform": "translate3d(" + x * 20 + "px, " + y * 20 + "px, 0) scale(1.05)"
                });
            });

            // Touch device parallax effect based on device orientation
            if (window.DeviceOrientationEvent) {
                window.addEventListener('deviceorientation', function(e) {
                    if (e.beta && e.gamma) {
                        var x = e.gamma / 90;
                        var y = e.beta / 180;

                        $(".slide-bg").css({
                            "transform": "translate3d(" + x * 20 + "px, " + y * 20 + "px, 0) scale(1.05)"
                        });
                    }
                });
            }
        });

        // INSTA REELS
$(document).ready(function() {

  // --- Hero Slider Initialization (Owl Carousel) ---
  // ... (keep your existing Hero Slider JS as is) ...

  // --- Instagram Reels Slider Initialization (Owl Carousel) ---
  const instareelSection = document.querySelector('.instareelsection');

  if (instareelSection) {
    const instareelOwlCarousel = $(instareelSection).find('.instareel-owl-carousel');

    const itemsDesktop = parseInt(instareelSection.dataset.itemsDesktop || 4, 10);
    const itemsMobile = parseInt(instareelSection.dataset.itemsMobile || 1, 10);
    const enableAutoplayInsta = (instareelSection.dataset.autoplayEnabled === 'true');
    const autoplaySpeedInsta = parseInt(instareelSection.dataset.autoplaySpeed || 5000, 10);

    instareelOwlCarousel.owlCarousel({
        loop: true,
        margin: 20,
        nav: false,
        dots: false,
        autoplay: enableAutoplayInsta,
        autoplayTimeout: autoplaySpeedInsta,
        autoplayHoverPause: true,
        smartSpeed: 800,
        responsive: {
            0: {
                items: itemsMobile,
                center: true,
                margin: 10
            },
            576: {
                items: 2
            },
            768: {
                items: 3
            },
            992: {
                items: itemsDesktop,
                nav: false
            },
            1200: {
                items: 5
            }
        },
        onInitialized: function(event) {
          // Play videos in initially active items
          $(event.target).find('.owl-item.active .instareelsection__video').each(function() {
            const video = this;
            const playButton = $(video).siblings('.instareelsection__play');
            const shouldAutoplay = video.hasAttribute('autoplay');
            const isMuted = video.hasAttribute('muted');

            if (shouldAutoplay && isMuted) {
              video.play();
              playButton.find('i').removeClass('fa-play').addClass('fa-pause');
              playButton.addClass('is-playing'); // Add class to play button parent
            } else {
              // Ensure play button reflects paused state if not auto-playing
              playButton.find('i').removeClass('fa-pause').addClass('fa-play');
              playButton.removeClass('is-playing');
            }
          });
        },
        onTranslate: function(event) { // <--- NEW: Fires BEFORE transition #}
          // Pause all videos in the slider before the next set of slides comes into view
          $(event.target).find('.instareelsection__video').each(function() {
            this.pause();
            $(this).siblings('.instareelsection__play').find('i').removeClass('fa-pause').addClass('fa-play');
            $(this).siblings('.instareelsection__play').removeClass('is-playing');
          });
        },
        onTranslated: function(event) { // <--- MODIFIED: Fires AFTER transition #}
          // Play videos only in the currently active/visible real items
          // Owl Carousel's 'stage' contains the actual items in the viewport
          $(event.target).find('.owl-item.active').each(function() {
            const video = $(this).find('.instareelsection__video')[0];
            if (video) {
              const playButton = $(video).siblings('.instareelsection__play');
              const shouldAutoplay = video.hasAttribute('autoplay');
              const isMuted = video.hasAttribute('muted');

              if (shouldAutoplay && isMuted) {
                video.play();
                playButton.find('i').removeClass('fa-play').addClass('fa-pause');
                playButton.addClass('is-playing');
              } else {
                playButton.find('i').removeClass('fa-pause').addClass('fa-play');
                playButton.removeClass('is-playing');
              }
            }
          });
        }
    });

    // Custom Navigation for Instagram Reels
    $(instareelSection).find('.instareelsection__nav--prev').click(function() {
        instareelOwlCarousel.trigger('prev.owl.carousel');
    });
    
    $(instareelSection).find('.instareelsection__nav--next').click(function() {
        instareelOwlCarousel.trigger('next.owl.carousel');
    });

    // Handle inline video play/pause on click (from previous step)
    $(instareelSection).on('click', '.js-video-toggle', function() {
        const videoId = $(this).data('videoId');
        const video = document.getElementById(videoId);
        if (video) {
            if (video.paused) {
                video.play();
                $(this).find('i').removeClass('fa-play').addClass('fa-pause');
                $(this).addClass('is-playing');
            } else {
                video.pause();
                $(this).find('i').removeClass('fa-pause').addClass('fa-play');
                $(this).removeClass('is-playing');
            }
        }
    });

  } // End if (instareelSection)

  // --- Video Modal Logic (Keep this from previous steps) ---
  const videoModal = document.getElementById('videoModal');
  const videoModalClose = document.querySelector('.video-modal-close');
  const videoModalIframeWrapper = document.querySelector('.video-modal-iframe-wrapper');

  document.querySelectorAll('.js-open-reel-modal').forEach(playButton => {
    playButton.addEventListener('click', function() {
      const videoUrl = this.dataset.videoUrl;
      if (videoUrl) {
        const instagramEmbedSrc = `https://www.instagram.com/p/${extractInstagramShortcode(videoUrl)}/embed/`;
        videoModalIframeWrapper.innerHTML = `
          <iframe
            src="${instagramEmbedSrc}"
            width="100%"
            height="100%"
            frameborder="0"
            scrolling="no"
            allowtransparency="true"
            allowfullscreen
            style="width: 100%; height: 100%; border: none;">
          </iframe>
        `;
        videoModal.style.display = 'flex';
        document.body.style.overflow = 'hidden';
      }
    });
  });

  if (videoModalClose) {
    videoModalClose.addEventListener('click', function() {
      videoModal.style.display = 'none';
      videoModalIframeWrapper.innerHTML = '';
      document.body.style.overflow = '';
    });
  }

  if (videoModal) {
    videoModal.addEventListener('click', function(event) {
      if (event.target === videoModal) {
        videoModal.style.display = 'none';
        videoModalIframeWrapper.innerHTML = '';
        document.body.style.overflow = '';
      }
    });
  }

  function extractInstagramShortcode(url) {
    const match = url.match(/(?:instagram\.com\/(?:p|reel)\/|instagr\.am\/p\/)([a-zA-Z0-9_-]+)/);
    return match ? match[1] : '';
  }

});

        document.addEventListener('DOMContentLoaded', function() {
            // Get all videos
            const videos = document.querySelectorAll('.videoproductlist__video');
            
            // Get all mute toggle buttons
            const muteButtons = document.querySelectorAll('.videoproductlist__mute-toggle');
            
            // Enable autoplay
            videos.forEach(video => {
                // Ensure autoplay starts as soon as possible
                video.setAttribute('autoplay', '');
                video.setAttribute('muted', '');
                video.setAttribute('playsinline', ''); // Important for iOS
                video.setAttribute('loop', '');
                
                // Force playback
                video.play().catch(error => {
                    console.log('Autoplay prevented by browser policy');
                });
            });
            
            // Add click event for mute/unmute
            muteButtons.forEach(btn => {
                btn.addEventListener('click', function(e) {
                    e.stopPropagation();
                    
                    const videoIndex = parseInt(this.getAttribute('data-video')) - 1;
                    const video = videos[videoIndex];
                    const icon = this.querySelector('i');
                    
                    if (video.muted) {
                        // First mute all videos
                        videos.forEach(v => v.muted = true);
                        
                        // Reset all icons
                        muteButtons.forEach(b => {
                            b.querySelector('i').className = 'fas fa-volume-mute';
                        });
                        
                        // Unmute current video
                        video.muted = false;
                        icon.className = 'fas fa-volume-up';
                    } else {
                        // Mute current video
                        video.muted = true;
                        icon.className = 'fas fa-volume-mute';
                    }
                });
            });
            
            // Ensure videos play on viewport entry
            // This uses Intersection Observer API
            if ('IntersectionObserver' in window) {
                const videoObserver = new IntersectionObserver((entries, observer) => {
                    entries.forEach(entry => {
                        if (entry.isIntersecting) {
                            // Video is visible in viewport
                            entry.target.play().catch(e => {
                                // Autoplay might be prevented
                                console.log('Could not autoplay video');
                            });
                        }
                    });
                }, {
                    threshold: 0.2 // 20% of the video must be visible
                });
                
                // Observe all videos
                videos.forEach(video => {
                    videoObserver.observe(video);
                });
            }
        });

        // Enhanced JavaScript with smoother progress and completion effects
        window.addEventListener('DOMContentLoaded', () => {
            const progressBar = document.getElementById('progress');
            const preloader = document.getElementById('preloader');
            const mainContent = document.getElementById('content');
            let progress = 0;
            
            // Function to simulate varying loading speeds for more natural progress
            const simulateLoading = () => {
                const loadingInterval = setInterval(() => {
                    if (progress >= 100) {
                        clearInterval(loadingInterval);
                        completeLoading();
                    } else {
                        // Variable speed progress for more natural effect
                        const increment = Math.random() * 2 + 0.5;
                        progress = Math.min(progress + increment, 100);
                        progressBar.style.width = `${progress}%`;
                        // Add slight slowdown near completion points for dramatic effect
                        if (progress > 85 && progress < 95) {
                            progress += 0.1;
                        }
                    }
                }, 30);
            };
            
            // Function to handle completion animations
            const completeLoading = () => {
                // Ensure progress bar is completely filled
                progressBar.style.width = '100%';
                
                // Add a slight delay before showing content
                setTimeout(() => {
                    // Fade out preloader
                    preloader.classList.add('fade-out');
                    
                    // Fade in content
                    mainContent.classList.add('visible');
                    
                    // Optional: Remove preloader from DOM after animation completes
                    setTimeout(() => {
                        preloader.style.display = 'none';
                        
                        // Show modal after content is visible
                        // setTimeout(function() {
                        //     var newsletterModal = new bootstrap.Modal(document.getElementById('newsletterModal'), {
                        //         backdrop: 'static',
                        //         keyboard: true
                        //     });
                        //     newsletterModal.show();
                        // }, 800);
                        
                    }, 5000);
                }, 500);
            };
            
            // Start the loading simulation
            simulateLoading();
            
            // Optional: Skip preloader with double click (for development purposes)
            document.addEventListener('dblclick', () => {
                progress = 100;
                progressBar.style.width = '100%';
                completeLoading();
            });
            
            // Handle form submission
            document.getElementById('newsletter-form').addEventListener('submit', function(e) {
                e.preventDefault();
                var email = this.querySelector('input[type="email"]').value;
                
                // You would typically send this to your server
                console.log('Email submitted:', email);
                
                // Show success message
                this.innerHTML = '<div class="text-center"><i class="fas fa-check-circle text-success" style="font-size: 48px;"></i><h4 class="mt-3">Thank You!</h4><p class="text-muted">You\'ve been successfully entered into our contest.</p></div>';
                
                // Close the modal after 3 seconds
                setTimeout(function() {
                    bootstrap.Modal.getInstance(document.getElementById('newsletterModal')).hide();
                }, 3000);
            });
            
            // Handle "Show popup again" button
            // document.getElementById('trigger-modal').addEventListener('click', function() {
            //     var newsletterModal = new bootstrap.Modal(document.getElementById('newsletterModal'));
            //     newsletterModal.show();
            // });
        });


        // Change main image when thumbnail is clicked
        function changeImage(newSrc, thumbnail) {
            const mainImg = document.getElementById('mainImg');
            const thumbnails = document.querySelectorAll('.pp-thumbnail');
            
            // Update active thumbnail
            thumbnails.forEach(thumb => thumb.classList.remove('active'));
            thumbnail.classList.add('active');
            
            // Fade out effect
            mainImg.style.opacity = '0';
            
            setTimeout(() => {
                mainImg.src = newSrc;
                mainImg.style.opacity = '1';
            }, 200);
        }

        // Add smooth transition for image changes
        document.addEventListener('DOMContentLoaded', function() {
            const mainImg = document.getElementById('mainImg');
            mainImg.style.transition = 'opacity 0.3s ease, transform 0.5s ease';
        });

        // Quantity controls
        function increaseQuantity() {
            const input = document.getElementById('quantity');
            if (parseInt(input.value) < 10) {
                input.value = parseInt(input.value) + 1;
            }
        }

        function decreaseQuantity() {
            const input = document.getElementById('quantity');
            if (parseInt(input.value) > 1) {
                input.value = parseInt(input.value) - 1;
            }
        }

        // Tab functionality
        function showTab(tabName) {
            const tabs = document.querySelectorAll('.pp-tab-content');
            const buttons = document.querySelectorAll('.pp-tab-btn');
            
            tabs.forEach(tab => {
                tab.classList.remove('active');
            });
            
            buttons.forEach(btn => {
                btn.classList.remove('active');
            });
            
            document.getElementById(tabName).classList.add('active');
            event.target.classList.add('active');
        }

        // Add to cart animation
        document.querySelector('.pp-btn-primary').addEventListener('click', function() {
            this.style.transform = 'scale(0.95)';
            setTimeout(() => {
                this.style.transform = '';
                alert('Added to cart!');
            }, 200);
        });

        // Zoom functionality
        const mainImage = document.getElementById('mainImage');
        
        mainImage.addEventListener('mousemove', function(e) {
            const img = this.querySelector('img');
            const rect = this.getBoundingClientRect();
            const x = ((e.clientX - rect.left) / rect.width) * 100;
            const y = ((e.clientY - rect.top) / rect.height) * 100;
            
            img.style.transformOrigin = `${x}% ${y}%`;
        });

        mainImage.addEventListener('mouseleave', function() {
            const img = this.querySelector('img');
            img.style.transformOrigin = 'center center';
        });

        // Color selection
        document.querySelectorAll('.pp-color-option').forEach(colorOption => {
            colorOption.addEventListener('click', function() {
                document.querySelectorAll('.pp-color-option').forEach(opt => opt.classList.remove('active'));
                this.classList.add('active');
            });
        });


      




